import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useSave } from '../graphql/hooks';
// import { Api, Utils } from '@jesseteal/teal-react'

interface MaterialFormProps {
  model: any;
  onClose?: () => void;
}
const MaterialForm = ({ model, onClose }: MaterialFormProps) => {
  const save = useSave('material', 'material');

  return (
    <SimpleForm
      header="Material Editor"
      cancel={onClose}
      model={model}
      save={({ modified, merged }: { modified: any; merged: any }) => {
        if (Boolean(model.id)) {
          save({
            id: model.id,
            ...modified,
          });
        } else {
          save(merged, true);
        }
        onClose?.();
      }}
      fields={[
        {
          label: 'Material',
          name: 'name',
          size: 12,
          validate: { required: true },
        },
        {
          name: 'price',
          label: 'Price',
          size: 3,
          validate: { required: true },
          number: true,
        },
        {
          name: 'density',
          label: 'Density',
          size: 3,
          validate: { required: true },
          number: true,
        },
      ]}
    />
  );
};

export default MaterialForm;
